export const filterOptions = [
  { name: "ICC ID", value: "iccid" },
  { name: "Updated Date", value: "date" },
  { name: "Updated By", value: "createdBy" },
  { name: "Report Status", value: "status" },
];

export const statusList = ["Available", "Skipped", "Failed"];
